export default "__VITE_ASSET__MG4IOaY4__"